import { render, staticRenderFns } from "./EditQuotasDialog.vue?vue&type=template&id=d9d82c46&"
import script from "./EditQuotasDialog.vue?vue&type=script&lang=js&"
export * from "./EditQuotasDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports